import { createApp } from 'vue'
import App from '../src/app/App.vue'
import store from './app/shared/store'
createApp(App).use(store).mount('#app')
